<template>
<div>
    <div v-if="user.role == '模具买家'">
        <p>当前身份为模具买家无法创建工厂</p>
    </div>
    <div v-else>
        <div v-if="count == 0">
            <p>当前账号没有创建工厂</p>
            <router-link tag="a" :to="{
                name:'CreateFactory',
            }">
                <el-button>立即创建</el-button>
            </router-link>
            
        </div>
        <div v-else>
            <p>{{factory.factory_name}}</p>
        </div>
    </div>
</div>
    
</template>

<script>
import store from '@/store'
export default {
    name:"MyFactory",
    data(){
        return{
            user:{},
            factorys:[],
            formData:{
                page:1,
            },
            count:0,
            factory:{}
        }
    },
    methods:{

    },
    created(){
        this.user = store.getters.userInfo
        this.$http
        .get("/v2/validate/SearchMyFactory", { 
        })
        .then(res => {
          this.factorys = res.data;
          this.count = res.count;
          this.factory = factorys[0]
        })
        .catch(error => {
          console.log(error);
        });
    }
}
</script>

<style scoped>

</style>